import { useContext, useEffect, useRef } from 'react';
import useSmartState from '../../common/hooks/useSmartState';
import FormBuilder from '../../library/Builders/FormBuilder';
import { SmartContext } from '../../library/Core/SmartContext';
import { FormSection } from '../../library/Core/SmartTypes';
import SchoolApiService, { PAGE_SIZE } from './SchoolApiService';

const SearchCriteria = () => {
    const { state, dispatch } = useContext(SmartContext);
    const searchFormConfig = state.formConfig?.sectionRepository[0] as FormSection;
    const { setStateValue } = useSmartState();
    const isFirstRun = useRef(true);

    const resetFilters = () => {
        var defaultSearchCriteria = SchoolApiService.getDefaultSearchCriteria(0,0,'');
        defaultSearchCriteria.classCode = [];
        defaultSearchCriteria.passOutYear = [];
        defaultSearchCriteria.schoolGroupId = [];
        defaultSearchCriteria.schoolId = [];
        defaultSearchCriteria.searchBy = [];

        var buttons = document.querySelectorAll('.row.g-3 button');
        buttons.forEach(function(button) {
            button.textContent = '';
        });
        setStateValue('searchCriteria', defaultSearchCriteria);
    };

    useEffect(() => {
        // The loader already fetched page 1; skip the duplicate fetch on first mount.
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }

        SchoolApiService.search(state.data.searchCriteria, state.routeInfo.pageName, 1, PAGE_SIZE).then((response: any) => {
            const payload = response.data ?? {};
            const rows = Array.isArray(payload) ? payload : (payload.data ?? []);
            const total = Array.isArray(payload) ? rows.length : (payload.total ?? rows.length);

            setStateValue('studentList', rows);
            dispatch({ type: 'SET_INTERNAL_STATE', payload: { key: 'page', value: 1 } });
            dispatch({ type: 'SET_INTERNAL_STATE', payload: { key: 'limit', value: PAGE_SIZE } });
            dispatch({ type: 'SET_INTERNAL_STATE', payload: { key: 'total', value: total } });
            dispatch({ type: 'SET_INTERNAL_STATE', payload: { key: 'hasMore', value: rows.length < total } });
            dispatch({ type: 'SET_INTERNAL_STATE', payload: { key: 'isLoadingMore', value: false } });
        });
    }, [state.data.searchCriteria]);

    return (
        <div>
            <div className="fitergroup mb-3">
                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" style={{}}>
                    <div className="accordion-body p-4">
                        <div className="row g-3">
                            <FormBuilder key="searchCriteria" section={searchFormConfig} dataKey="searchCriteria" />
                        </div>
                        <button className="btn btn-reset field w-auto" onClick={resetFilters}><i className="icon-reset"></i> Reset Filters</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchCriteria;
